import { Form, Tooltip } from 'antd';
import { PropsWithChildren } from 'react';
import { AlertCircle } from 'react-feather';
import { useLabelPrintingContext } from '..';
import Group from '../../Group';
import StatusTag from '../../StatusTag';
import WrapperLabelPrintingPageContentPaper from '../PageContentPaper';

export default function WrapperLabelPrintingWrapperPageContent({
  children,
}: PropsWithChildren<unknown>) {
  const { form } = useLabelPrintingContext();
  const values = Form.useWatch([], form);

  const preset = values?.preset?.toUpperCase();
  const width = values?.layout?.width || 0;
  const height = values?.layout?.height || 0;

  return (
    <>
      <div className="print-page-content-wrapper-header">
        <Group gap={10}>
          <Tooltip title="Resultado final pode ser um pouco diferente">
            <StatusTag
              label={
                <Group gap={4}>
                  <span>Pré-Visualização</span> <AlertCircle size={14} />
                </Group>
              }
              color="blue"
            />
          </Tooltip>

          <StatusTag label={`${preset} - ${width}/${height} mm`} />
        </Group>
      </div>

      <div style={{ minHeight: 'auto', flex: 1 }}>
        <div className="print-page-content-wrapper-paper">
          <WrapperLabelPrintingPageContentPaper>
            {children}
          </WrapperLabelPrintingPageContentPaper>
        </div>
      </div>
    </>
  );
}
